import { useListing } from 'framework-listing-lib/internal/providers/ListingProvider';
export default function useSkipCrm() {
  const {
    skipCrm
  } = useListing();
  return Boolean(skipCrm);
}